import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import SelectDropdown from "../../components-react/SelectDropdown";
import MultiSelect from "../../components-react/MultiSelect";
import PlacesSearch from "../../common-components/SearchedPlaces";
import { languages } from "../../common-data/DropdowData";
import { fetchExpertiseData } from "../../../redux/reducers/apiSlice";
import { fetchGymData } from "../../../data/APIs";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchUsersData } from "../../../redux/reducers/dropdownApiSlice";
import { toast } from "react-toastify";
import { addDietician } from "../../../redux/reducers/postApiSlice";
import { updateDietician } from "../../../redux/reducers/putApiSlice";

const DieticianForm = ({
  closeModal,
  decryptedText,
  name,
  rowData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { expertiseData } = useSelector((state) => state.api);
  const { usersData } = useSelector((state) => state.dropdown);

  const iniDropdownData = {
    allUsers: [],
    allExpertise: [],
  };
  const [dropdownData, setDropdownData] = useState(iniDropdownData);

  const selectedExpertises = rowData?.expertise_id
    ?.split(",")
    ?.map((expertise) => ({
      label: dropdownData.allExpertise[expertise]?.label || expertise,
      value: expertise,
    }));

  const selectedLanguages = rowData?.language?.split(",")?.map((language) => ({
    label: languages[language]?.label || language,
    value: language,
  }));
  const iniFormValues = {
    selectedGym:
      name === "edit" && (rowData?.gym_name || rowData?.gym_id)
        ? {
            label: rowData.gym_name,
            value: rowData.gym_id,
          }
        : "",
    selectedNutritionist:
      name === "edit" && (rowData?.dietitian_name || rowData?.dietitian_id)
        ? {
            label: rowData.dietitian_name,
            value: rowData.dietitian_id,
          }
        : "",
    searchedLocation: "",
    address1: name === "edit" && rowData?.address1 ? rowData.address1 : "",
    address2: name === "edit" && rowData?.address2 ? rowData.address2 : "",
    city: name === "edit" && rowData?.city ? rowData.city : "",
    state: name === "edit" && rowData?.state ? rowData.state : "",
    pincode: name === "edit" && rowData?.pin ? rowData.pin : "",
    country: name === "edit" && rowData?.country ? rowData.country : "",
    selectedExperties:
      name === "edit" && selectedExpertises ? selectedExpertises : [],
    experience:
      name === "edit" && rowData?.experience ? rowData.experience : "",
    selectedLanguages:
      name === "edit" && selectedLanguages ? selectedLanguages : [],
    description:
      name === "edit" && rowData?.trainer_description
        ? rowData.trainer_description
        : "",
    doj:
      name === "edit" && rowData?.date_of_joining
        ? rowData.date_of_joining
        : "",
    isActive: name === "edit" && rowData?.status ? rowData.status : "active",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type } = e.target;
    setIsSubmit(false);
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checked" ? true : value,
    }));
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);
    setFormValues({ ...formValues, [name]: value });
  };

  const handlePlaceChange = (selectedLocation) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      searchedLocation: selectedLocation.formatted_address,
      address1: selectedLocation.address1,
      address2: selectedLocation.address2,
      city: selectedLocation.city,
      state: selectedLocation.state,
      pincode: selectedLocation.pincode,
      country: selectedLocation.selectedCountry,
    }));
  };

  // const handleLanguageChange = (selectedLanguage) => {
  //   setFormValues((prevFormValues) => ({
  //     ...prevFormValues,
  //     selectedLanguages: [
  //       ...prevFormValues.selectedLanguages,
  //       selectedLanguage,
  //     ],
  //   }));
  // };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const validateForm = (formValues) => {
    let errors = {};

    if (!formValues.selectedGym) {
      errors.selectedGym = "Gym is required!";
    }

    if (!formValues.selectedNutritionist) {
      errors.selectedNutritionist = "User is required!";
    }

    if (!formValues.address1) {
      errors.address1 = "Address 1 is required";
    }

    if (!formValues.address2) {
      errors.address2 = "Address 2 is required!";
    }

    if (!formValues.city) {
      errors.city = "City is required!";
    }

    if (!formValues.state) {
      errors.state = "State is required!";
    }

    if (!formValues.pincode) {
      errors.pincode = "Pin code is required!";
    } else if (formValues.pincode && formValues.pincode.length !== 6) {
      errors.pincode = "Pin code must be 6 digits!";
    }

    if (!formValues.country) {
      errors.country = "Country is required!";
    }

    if (!formValues.selectedExperties) {
      errors.selectedExperties = "Expertise is required!";
    }

    if (!formValues.experience) {
      errors.experience = "Experience is required!";
    }

    if (!formValues.selectedLanguages) {
      errors.selectedLanguage = "Language is required!";
    }

    if (!formValues.description) {
      errors.description = "Description is required!";
    }

    if (!formValues.doj) {
      errors.doj = "Date Of Joining is required!";
    }

    return errors;
  };

  const handleAddDietician = async (requestBody, TOKEN) => {
    setIsSubmit(false);

    try {
      const actionResult =
        name === "edit"
          ? dispatch(updateDietician({ requestBody, TOKEN }))
          : dispatch(addDietician({ requestBody, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        setFormErrors({});
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleAddDietician ERROR => ", error);
    }
  };

  useEffect(() => {
    dispatch(fetchGymData(decryptedText?.token));
  }, []);

  useEffect(() => {
    dispatch(
      fetchUsersData({
        token: decryptedText?.token,
        qps: formValues.selectedGym?.value
          ? `gym_id=${formValues.selectedGym.value}`
          : "",
        pageNo: 1,
        limit: 100,
      })
    );
  }, [formValues.selectedGym?.value]);

  useEffect(() => {
    dispatch(
      fetchExpertiseData({
        pageNo: 1,
        limit: 100,
        queryParameters: "",
        token: decryptedText?.token,
      })
    );
  }, []);

  useEffect(() => {
    if (expertiseData?.status && expertiseData?.data?.length > 0) {
      const expertises = expertiseData.data.map((exp) => ({
        label: exp?.expertise_name,
        value: exp?.uid,
      }));

      setDropdownData((prevs) => ({ ...prevs, allExpertise: expertises }));
    } else {
      setDropdownData((prevs) => ({ ...prevs, allExpertise: [] }));
    }

    if (usersData) {
      setDropdownData((prevs) => ({ ...prevs, allUsers: usersData }));
    } else {
      setDropdownData((prevs) => ({ ...prevs, allUsers: [] }));
    }
  }, [expertiseData, usersData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const selectedExpertiseValues = formValues.selectedExperties
        .map((expertise) => expertise.value)
        .join(",");
      const selectedLanguageValues = formValues.selectedLanguages
        .map((language) => language.value)
        .join(",");

      const userData = {
        dietitian_id: formValues.selectedNutritionist?.value,
        gym_id: formValues.selectedGym?.value,
        address1: formValues.address1,
        address2: formValues.address2,
        city: formValues.city,
        state: formValues.state,
        pin: formValues.pincode,
        country: formValues.country,
        experience: formValues.experience,
        language: selectedLanguageValues,
        expertise_id: selectedExpertiseValues,
        trainer_description: formValues.description,
        date_of_joining: formValues.doj,
        status: formValues.isActive ? "active" : "inactive",
      };

      if (name === "edit") {
        userData.uid = rowData?.uid;
      }

      handleAddDietician(userData, decryptedText?.token);
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mealsModalContainer addMealModal">
      <CommonHeadingNBtns
        title="Add dieticains"
        onClose={closeModal}
        onClick={onSubmit}
      />

      <form className="formContainer">
        <div className="formInputsGrid fourGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedGym" className={`formInputLabel `}>
              Select gym *
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedGym && "formError"
              }`}>
              <SelectDropdown
                options={gymData}
                selectedOption={formValues.selectedGym}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedGym")
                }
                name="Gym"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedNutritionist" className={`formInputLabel `}>
              Select user *
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedNutritionist && "formError"
              }`}>
              <SelectDropdown
                options={dropdownData.allUsers}
                selectedOption={formValues.selectedNutritionist}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedNutritionist")
                }
                name="User"
              />
            </div>
          </div>

          <>
            <div className="formInputBox searchInput">
              <label
                htmlFor="searchedLocation"
                className={`formInputLabel ${
                  formErrors?.searchedLocation && "formError"
                }`}>
                Search location *
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.searchedLocation ? "formError" : ""
                }`}>
                <PlacesSearch handlePlaceChange={handlePlaceChange} />
                {/* <SelectDropdown
                  options={[]}
                  selectedOption={formValues.searchedLocation}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "searchedLocation")
                  }
                  name="Enter Your Location"
                /> */}
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="address1" className="formInputLabel">
                Address 1
              </label>

              <input
                type="text"
                className={`formInput ${formErrors.address1 && "formError"}`}
                name="address1"
                placeholder="Enter Your Address"
                value={formValues.address1}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="address2" className="formInputLabel">
                Address 2
              </label>

              <input
                type="text"
                className={`formInput ${formErrors.address2 && "formError"}`}
                name="address2"
                placeholder="Enter Your Address"
                value={formValues.address2}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="city" className="formInputLabel">
                City
              </label>

              <input
                type="text"
                className={`formInput ${formErrors.city && "formError"}`}
                name="city"
                placeholder="Enter Your city"
                value={formValues.city}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="state" className="formInputLabel">
                state
              </label>

              <input
                type="text"
                className={`formInput ${formErrors.state && "formError"}`}
                name="state"
                placeholder="Enter Your state"
                value={formValues.state}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="pincode" className="formInputLabel">
                pin
              </label>

              <input
                type="number"
                className={`formInput ${formErrors.pincode && "formError"}`}
                name="pincode"
                placeholder="Enter Your pincode"
                value={formValues.pincode}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label
                htmlFor="country"
                className={`formInputLabel ${
                  formErrors?.country && "formError"
                }`}>
                Country *
              </label>

              <input
                type="text"
                className={`formInput ${formErrors.country && "formError"}`}
                name="country"
                placeholder="Enter Your country"
                value={formValues.country}
                onChange={onChangeInput}
              />

              {/* <div
                className={`commonWrapper ${
                  formErrors?.selectedCountry && "formError"
                }`}
              >
                <SelectDropdown
                  options={[]}
                  selectedOption={formValues.selectedCountry}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedCountry")
                  }
                  name="Country"
                />
              </div> */}
            </div>
          </>

          <div className="formInputBox">
            <label htmlFor="selectedExperties" className="formInputLabel">
              choose Expertise *
            </label>

            <div
              className={`commonWrapper multiSelect ${
                formErrors?.selectedExperties ? "formError" : ""
              }`}>
              <MultiSelect
                options={dropdownData.allExpertise}
                state={formValues.selectedExperties}
                setState={(selectedValue) =>
                  setFormValues((prevs) => ({
                    ...prevs,
                    selectedExperties: selectedValue,
                  }))
                }
                name="selectedExperties"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="experience" className="formInputLabel">
              Experience
            </label>

            <input
              type="number"
              className={`formInput ${formErrors.experience && "formError"}`}
              name="experience"
              placeholder="Enter Total Experience"
              value={formValues.experience}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedLanguages" className="formInputLabel">
              Languages *
            </label>

            <div
              className={`commonWrapper multiSelect ${
                formErrors?.selectedLanguages ? "formError" : ""
              }`}>
              <MultiSelect
                options={languages}
                state={formValues.selectedLanguages}
                setState={(selectedValue) =>
                  setFormValues((prevs) => ({
                    ...prevs,
                    selectedLanguages: selectedValue,
                  }))
                }
                name="selectedLanguages"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="doj" className="formInputLabel">
              Date of Joining *
            </label>

            <input
              type="date"
              className={`formInput ${formErrors.doj && "formError"}`}
              name="doj"
              placeholder="Enter Your doj"
              value={formValues.doj}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox gridCoulmn4">
            <label htmlFor="description" className="formInputLabel">
              Description *
            </label>

            <textarea
              name="description"
              className={`formInput ${formErrors?.description && "formError"}`}
              placeholder="Write something"
              value={formValues.description}
              onChange={onChangeInput}></textarea>
          </div>
        </div>

        <div className="formInputsGrid switchInputs">
          <div className="formInputBox formInputSwitchBox">
            <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                formErrors?.isActive && "formError"
              }`}>
              <Form.Check
                type="switch"
                name="isActive"
                label={`${formValues.isActive ? "Active" : "Not Active"}`}
                value={formValues.isActive}
                onChange={onChangeInput}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DieticianForm;
